import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { Pluralize } from "./Pluralize";

interface PluralizeContainerProps {
    expression: EvaluableProp<string>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    oneElementWordForm: string;
    fourElementsWordForm: string;
    fiveElementsWordForm: string;
}

const mapStateToProps = (state: FullFormState, ownProps: PluralizeContainerProps) => ({
    count: Number(ownProps.processEvaluableProp(state, ownProps.expression)),
});

export const PluralizeContainer = withResolvePaths(
    withViewModelSelect(withEvaluators(connect(mapStateToProps)(Pluralize)))
);
